import { get } from 'lodash';

export const getIsICUBaseUrlEnabled = (appParams) =>
  get(appParams, 'baseUrls.useICU') === 'true';
